import React from 'react';
import PropTypes from 'prop-types';

import Category from 'components/Highlights/Breakdown/category';

const CurrentsBreakdownBar = ({ mentionCounts }) => {
  if (!mentionCounts) return null;

  const data = Object.entries(mentionCounts)
    .filter(([, count]) => count > 0)
    .map(([post_type, mention_count]) => ({ post_type, mention_count }));

  const categories = Category.buildFromData(data).filter((c) => c.mentionCount > 0);
  const total = categories.reduce((sum, c) => sum + c.mentionCount, 0);
  if (total === 0) return null;

  return (
    <span className="CurrentsCard-breakdown-bar" aria-hidden="false">
      {categories.map((category) => {
        const width = (category.mentionCount / total) * 100;
        const label = I18n.t(category.name, {
          scope: 'Explorer.Highlights.Breakdown.categories',
          defaultValue: category.name
        });
        return (
          <span
            key={category.name}
            className="CurrentsCard-breakdown-segment"
            style={{ width: `${width}%`, backgroundColor: category.color }}
            title={`${label}: ${category.mentionCount.toLocaleString()}`}
          />
        );
      })}
    </span>
  );
};

CurrentsBreakdownBar.propTypes = {
  mentionCounts: PropTypes.object
};

export default CurrentsBreakdownBar;
